import React from "react";

const FeatureContent = [
  {
    icon: "194",
    title: "Katalis Pengetahuan",
    subTitle: `Transfer ilmu berbasis praktik terbaik kolaborasi riset lintas negara, dan pelatihan berkelanjutan.`,
    bgColor: "#FFEBDB",
    delayAnimation: "",
  },
  {
    icon: "172",
    title: "Katalis Inovasi",
    subTitle: `Pendampingan startup, adopsi teknologi tepat guna, dan implementasi AI untuk sektor riil.`,
    bgColor: "#E0F8F8",
    delayAnimation: "200",
  },
  {
    icon: "134",
    title: "Katalis Sosial",
    subTitle: `Pemberdayaan UMKM, akses pasar global, dan transformasi ekonomi berbasis nilai.`,
    bgColor: "#F7EDFF",
    delayAnimation: "400",
  },
  {
    icon: "116",
    title: "Katalis Budaya",
    subTitle: `Pelestarian budaya lokal melalui platform digital dan kolaborasi seni lintas budaya.`,
    bgColor: "#E6F8EB",
    delayAnimation: "600",
  },
  {
    icon: "75",
    title: "Katalis Pencitraan Nasional",
    subTitle: `Membangun citra positif Indonesia di kancah global melalui kolaborasi diaspora.`,
    bgColor: "#FFF4E5",
    delayAnimation: "800",
  },
  {
    icon: "157",
    title: "Katalis Penempatan Strategis",
    subTitle: `Membuka pintu peluang melalui penempatan strategis diaspora di berbagai sektor.`,
    bgColor: "#EDEFFB",
    delayAnimation: "1000",
  },
];

const FancyFeatureTewentyThree = () => {
  return (
    <>
      {FeatureContent.map((val, i) => (
        <div
          className="col-lg-4 col-md-6"
          data-aos="fade-right"
          data-aos-duration="1200"
          data-aos-delay={val.delayAnimation}
          key={i}
        >
          <div className="block-style-twentyTwo">
            <div
              className="icon d-flex align-items-center justify-content-center"
              style={{ background: val.bgColor }}
            >
              <img src={`images/icon/${val.icon}.svg`} alt="icon" />
            </div>
            <h4>{val.title}</h4>
            <p>{val.subTitle}</p>
          </div>
        </div>
      ))}
    </>
  );
};

export default FancyFeatureTewentyThree;
